import { Chip } from '@/components/Chip';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { TranslationNS } from '@gokrew/models/constants';
import { LogType, DayStatus } from '@gokrew/models/timesheet';
import styles from './TimesheetChips.module.css';


const STATUS_CLASS: Record<DayStatus, string> = {
  [DayStatus.Full]: styles.chipFull,
  [DayStatus.Partial]: styles.chipPartial,
  [DayStatus.Off]: styles.chipOff,
  [DayStatus.Leave]: styles.chipLeave,
  [DayStatus.Holiday]: styles.chipHoliday,
};

export const TypeChip = ({ type }: { type: LogType }) => {
  const { t } = useTranslation(TranslationNS.Timesheet);
  return (
    <Chip
      className={cn(
        styles.chipBase,
        type === LogType.Break ? styles.chipBreak : styles.chipClock
      )}
    >
      {t(`detailsModal.table.chipType.${type}`)}
    </Chip>
  );
};

export const StatusChip = ({ status }: { status: string }) => {
  const { t } = useTranslation(TranslationNS.Timesheet);
  return (
    <Chip className={cn(styles.chipBase, STATUS_CLASS[status as DayStatus])}>
      {t(`detailsModal.table.chipStatus.${status}`)}
    </Chip>
  );
};
